import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Sidebar.css';

const Sidebar = ({ category, items, activeSection, onItemClick }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleItemClick = (item) => {
    if (onItemClick) {
      // 스크롤 스파이 기능이 있는 경우 (섹션 내부 네비게이션)
      onItemClick(item.path);
    } else {
      // 일반 페이지 이동
      navigate(item.path);
    }
  };

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2 className="sidebar-title">{category}</h2>
      </div>
      <nav className="sidebar-nav">
        <ul className="sidebar-list">
          {items.map((item, index) => {
            // 현재 경로에서 언어 코드를 제거한 경로와 비교
            const currentPathWithoutLang = location.pathname.replace(/^\/[a-z]{2}/, '');
            const itemPathWithoutLang = item.path.replace(/^\/[a-z]{2}/, '');
            
            const isActive = onItemClick 
              ? activeSection === item.path 
              : currentPathWithoutLang === itemPathWithoutLang;
              
            return (
              <li key={index} className="sidebar-item">
                <button
                  className={`sidebar-link ${isActive ? 'active' : ''}`}
                  onClick={() => handleItemClick(item)}
                >
                  {item.name}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
